import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LoaderService } from '@app/services/shared/loader.service';
import { LoaderState } from '@app/models/common/loaderState';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppSettings } from'@app/common/app-setting'

@Component({
    selector: 'angular-loader',
    templateUrl: 'loader.component.html',
    styleUrls: ['loader.component.css']
})
export class LoaderComponent implements OnInit, OnDestroy {
    show = 0;
    private subscription: Subscription;

    public sessionIdleTimeInSecond: number = 1;
    private interval: Subscription;
    constructor(
        private router: Router,
        private loaderService: LoaderService,
        private toastr: ToastrService
    ) { }
    ngOnInit() {
        this.subscription = this.loaderService.loaderState
            .subscribe((state: LoaderState) => {
                this.show = state.show;
                //Reset idle time if request has been made
                if (this.show > 0) {
                    this.sessionIdleTimeInSecond = 0;
                }
            });
        this.loaderService.checkUserSessionIdleTime().subscribe(num => {
            this.checkUserSessionIdleTime()
        });;

    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    checkUserSessionIdleTime() {
        if (this.show > 0) {
            this.sessionIdleTimeInSecond = 0;
        }
        else {
            ++this.sessionIdleTimeInSecond;
            if (this.sessionIdleTimeInSecond == 5000) {
                this.toastr.warning("Your session will be expired in 1 minute.");
            }
            if (this.sessionIdleTimeInSecond == 6000) {   //if user is idle for 10 min then logout 
                localStorage.clear();
                this.router.navigate([AppSettings.LoginPath]);
            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/components/common/loader/loader.component.ts